<div class="review-component">
  <div class="summary-grid">
    <div class="card contact request-details-border">
      <h4>Request Information</h4>
      <div class="row two">
        <label class="label-bold">Job Site Name
          <p class="review-info">{{this.cartData?.deliveryAddress?.companyName !== "" ? this.cartData?.deliveryAddress?.companyName : '-'}}</p>
        </label>
        <label class="label-bold">Address 1
          <p class="review-info">{{this.cartData?.deliveryAddress?.line1 !== "" ? this.cartData?.deliveryAddress?.line1 : '-'}}</p>
        </label>
        <label class="label-bold">Address 2
          <p class="review-info">{{this.cartData?.deliveryAddress?.line2 !== "" ? this.cartData?.deliveryAddress?.line2 : '-'}}</p>
        </label>
      </div>
      <div class="row two">
        <label class="label-bold">City
          <p class="review-info">{{this.cartData?.deliveryAddress?.town}}</p>
        </label>
        <label class="label-bold">State/Province
          <p class="review-info">{{this.cartData?.deliveryAddress?.region?.name}}</p>
        </label>
        <label class="label-bold">Postal Code
          <p class="review-info">{{this.cartData?.deliveryAddress?.postalCode}}</p>
        </label>
      </div>
      <div class="row two">
         <label class="label-bold">Country
          <p class="review-info">{{this.cartData?.deliveryAddress?.country?.name}}</p>
        </label>
        <label class="label-bold">Phone
          <p class="review-info">{{getFormattedPhone()}}</p>
        </label>
      </div>
    </div>
  </div>
  <div class="row one">
    <label class="label-bold"><b>Additional Information</b></label>
  </div>
  <div class="row one">
    <label class="label-bold">Multiple Shipments
      <p class="review-info">{{this.cartData?.multipleShipment ? 'Yes' : 'No'}}</p>
    </label>
  </div>
  <div class="row two">
    <label>Shipment Notes / Comments
      <p class="review-info">{{this.cartData?.deliveryAddress?.note || 'No comments provided.'}}</p>
    </label>
  </div>
  <div class="row two">
    <label class="label-bold">Uploaded Files
      <p class="review-info">No Files Uploaded</p>
    </label>
  </div>

  <div class="cart-summary-layout mt-3">
    <div class="cart-table-card">
      <div class="cart-table-header" aria-label="Shopping cart columns">
        <span class="header-product">Product</span>
        <span class="header-cell">Material #</span>
        <span class="header-cell">Qty</span>
        <span class="header-cell">Sales Unit</span>
        <span class="header-cell">Unit Price</span>
        <span class="header-cell">Total Price</span>
      </div>

      @for (item of cartItems; track item.id) {
      <div class="cart-item-row">
        <div class="product-cell">
          <div class="product-thumb" [class.small]="item.compactThumb" aria-hidden="true">
            <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
              [alt]="item?.product?.images?.altText">
            </cx-media>
          </div>
          <div class="product-details">
            {{ item.name }}
          </div>
        </div>
        <div class="value-cell">{{ item.partNumber }}</div>
        <div class="value-cell">
          {{ item.quantity }}
        </div>
        <div class="value-cell">{{ item.salesUnit }}</div>
        <div class="value-cell">
          {{ item?.knbrTotalPrice?.listPrice === 0 ? 'Quoted' : item?.knbrTotalPrice?.formatedListPrice }}
        </div>
        <div class="value-cell">
          {{ item?.totalPrice?.value === 0 ? 'Quoted' : item?.totalPrice?.formattedValue }}
        </div>
      </div>
      @if (item.notes?.trim()) {
            <div class="comments-row">
              <span class="comments-label">Comments:</span>
              <span class="comments-text" [title]="item.notes || ''">{{ item.notes }}</span>
            </div>
            }
      }
      <div class="cart-total">Total Items: <strong>{{ cartItems.length }}</strong></div>
    </div>
  </div>
</div>
